import { useEffect } from "react";

// Keeps the browser tab title in step with the active language. index.html
// ships a static English <title> for the first paint; this replaces it once
// React mounts and whenever the language changes.
export default function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
